import React, {useState, useEffect, useContext} from "react";
import { io } from "socket.io-client";
import "./PWall.scss";
import { useTranslation } from "react-i18next";
import Xbutton from "components/Xbutton";
import { useHistory } from 'react-router-dom';
import PlanToggleWithPayPalButtons from "./PlanToggleWithPayPalButtons";
import UserContext from "../../pages/Login/UserContext";
import { isUserSubscribed } from '../../utils/subscriptionUtils';

function PWall_Main({onExit, setSubscriptionID }) {
   
    const { t } = useTranslation();
    const history = useHistory();
    const {user, handleUserUpdate} = useContext(UserContext);

    const [PlanSelected, setPlanSelected] = useState("monthly")

    // component mounted (logs removed)
    useEffect(() => {
    }, []);

    const gotoLogin = () => {
      onExit(); // Close the paywall first
      history.push('/login');
    }

    return (
      <>
        <div className="PWall_container">
            <div className="PWall_container__nav">
              <Xbutton 
                sizeM
                onClose={onExit}
              />
              <div className="PWall_login-line">
                {user?.email ? (
                  // User is logged in - show email and switch account link
                  <div className="PWall_signed-in-info">
                    <span>{t("loginFlow.signedInAs")}: {user.email}</span>
                    <div className="PWall_login-line_link" onClick={gotoLogin}>{t("loginFlow.switchAccount")}</div>
                  </div>
                ) : (
                  // User is not logged in - show original message
                  <>
                <p>{t("loginFlow.alreadyAccount")}</p>
                    <div className="PWall_login-line_link" onClick={gotoLogin}>{t("loginFlow.logInBtn")}</div>
                  </>
                )}
              </div>
            </div>
            <div className="PWall_content">
              <div className="PWall_container__right">
                <div className="content">
                  <div className="PWall_-title">{t(`paywall-catbears.main-title`)}</div>
                </div>
                <div className="PWall_footer">
                  <PlanToggleWithPayPalButtons setSubscriptionID={setSubscriptionID}/>
                </div>
              </div>
              {/* <div className="PWall_container__left">
                <img src="/assets/course/theatre/course-thumbnail_theatre_03.jpg" alt="catbears theatre" />
              </div> */}
            </div>
          </div>
      </>
    )
  }
  
  export default PWall_Main